import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Activate cooldown',
  description:
    'You need to {activate} the cooldown before you can unstake your {asset} from the Security Module. This transaction is to {confirm} of the cooldown.',
  activate: 'activate',
  confirm: 'confirm the activation',
  activateCooldown: 'Activate Cooldown for {asset}',
  backToStaking: 'Back to staking',
  buttonTitle: 'Activate',

  notEnoughBalance: 'Your stake balance is 0',
});
